module.exports = __webpack_public_path__ + "img/additional-service-placeholder.da437d6d.svg";